module.exports = __webpack_public_path__ + "img/Local-Clips-Option-1.dcd16eb3.png";